import { render, staticRenderFns } from "./view-customer.vue?vue&type=template&id=54e551da&"
import script from "./view-customer.vue?vue&type=script&lang=ts&"
export * from "./view-customer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports